import { Component } from "@angular/core";



@Component({
  template: `
<div style="height: 100%">
  <ion-button (click)="makeError()">Produce Error</ion-button>
</div>
`,
  selector: 'test-sentry'
})
export class TestSentry {
  ngOnInit () {
  }
  async callFailingFunction () {
    throw new Error('testing sentry')
  }
  async makeError () {
    await this.callFailingFunction()
  }
}
